import React from "react";
import styled from "styled-components";
import { SmallNoteMateIcon } from "components/icons/NoteMateIcons/SmallNoteMateIcon";
import { useTranslation } from "react-i18next";
import { Typography14 } from "@slid/slid-ips";
import useNoteMateStore from "store/useNoteMateStore";

export const MainButton = ({
  location,
  handleNoteMateButtonClick,
  handleNoteMateButtonHover,
  showBanner,
}: {
  location: "plainNote" | "videoNote";
  handleNoteMateButtonClick: () => void;
  handleNoteMateButtonHover: (mouseEnter: boolean) => void;
  showBanner: boolean;
}) => {
  const { t } = useTranslation("NoteMate");
  const { isNoteMateOpen } = useNoteMateStore();

  if (location === "plainNote") {
    return (
      <HorizontalButtonContainer
        onClick={handleNoteMateButtonClick}
        onMouseEnter={() => handleNoteMateButtonHover(true)}
        onMouseLeave={() => handleNoteMateButtonHover(false)}
        isBannerVisible={showBanner}
        isNoteMateOpen={isNoteMateOpen}
      >
        <SmallNoteMateIcon />
        <Typography14 weight={500} color={`--gray15`} text={t("NoteMate")} />
      </HorizontalButtonContainer>
    );
  }
  return (
    <NoteMateButtonWrapper
      onClick={handleNoteMateButtonClick}
      onMouseEnter={() => handleNoteMateButtonHover(true)}
      onMouseLeave={() => handleNoteMateButtonHover(false)}
      isBannerVisible={showBanner}
      isNoteMateOpen={isNoteMateOpen}
    >
      <ButtonContainer isNoteMateOpen={isNoteMateOpen}>
        <SmallNoteMateIcon />
        <NoteMateButtonText>{t("NoteMate")}</NoteMateButtonText>
      </ButtonContainer>
    </NoteMateButtonWrapper>
  );
};

const NoteMateButtonWrapper = styled.div<{ isBannerVisible: boolean; isNoteMateOpen: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${({ isNoteMateOpen }) => (isNoteMateOpen ? "default" : "pointer")};
  width: 62px;
  height: 62px;
  border-radius: 15px;
  background-color: var(--white);
  box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.1);
  opacity: ${({ isNoteMateOpen }) => (isNoteMateOpen ? 0.4 : 1)};

  ${({ isBannerVisible }) =>
    isBannerVisible &&
    `
    box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.1), 0 0 0 2px var(--purple7);
  `}
`;

const ButtonContainer = styled.div<{ isNoteMateOpen: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 0px;
  border-radius: 15px;
  ${({ isNoteMateOpen }) =>
    !isNoteMateOpen &&
    `
    :hover {
      background: var(--gray3);
    }
  :active {
    background: var(--gray2);
    }
  `}
`;

const HorizontalButtonContainer = styled(NoteMateButtonWrapper)`
  flex-direction: row;
  justify-content: center;
  width: auto;
  height: auto;
  padding: 8px 15px 8px 12px;
  gap: 4px;
  border-radius: 12px;
`;

export const NoteMateButtonText = styled.span`
  color: var(--gray17);
  text-align: center;
  font-family: Pretendard;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px; /* 130% */
`;
